import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '@environment';
import { FeatureSettingModel } from '../models/user/feature-setting,model';
import { OrganizationModel } from '../models/user/organization.model';

@Injectable()
export class OrganizationService {

  constructor(private http: HttpClient) {
  }

  public getUserOrganizations(tecToken: string): Observable<OrganizationModel[]> {
    const headers = this.getTecTokenHeader(tecToken);

    return this.http.get<OrganizationModel[]>(`${environment.organizationServiceUrl}/v1/organization`, { headers });
  }

  public getOrganizationFeatures(tecToken: string, tecId: string): Observable<FeatureSettingModel> {
    const headers = this.getTecTokenHeader(tecToken);

    return this.http.get<FeatureSettingModel>(`${environment.organizationServiceUrl}/v1/organization/${tecId}/features`, { headers });
  }

  private getTecTokenHeader(tecToken: string): HttpHeaders{
    return new HttpHeaders({
      'X-Tec-Token': tecToken
    });
  }
}